module.exports = __webpack_public_path__ + "img/ryh.57409ca0.png";